import styled from '@emotion/styled'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { createDefectCommentAction } from '../../actions/defectComments/actions'
import { useTypedDispatch } from '../../index'
import { theme } from '../../Theme'
import TransparentButton from '../button/TransparentButton'
import Input from '../Input'

type Props = {
  defectId: string
  setSuccessToastVisible?: (visible: boolean) => void
  setErrorToastVisible?: (visible: boolean) => void
}

const CommentForm = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${theme.spacing.sizes.small};
`

export const CommentFormArea = ({
  defectId,
  setErrorToastVisible,
  setSuccessToastVisible,
}: Props) => {
  const [comment, setComment] = useState<string>('')
  const [defectCommentFormSubmitting, setDefectCommentFormSubmitting] = useState(false)
  const dispatch = useTypedDispatch()
  const { t } = useTranslation()

  return (
    <CommentForm
      onSubmit={async (e) => {
        e.preventDefault()

        if (!comment.trim()) {
          return
        }

        try {
          setDefectCommentFormSubmitting(true)

          await dispatch(
            createDefectCommentAction({
              comment,
              defectId,
            })
          ).unwrap()

          setComment('')

          if (setSuccessToastVisible) {
            setSuccessToastVisible(true)
            setTimeout(() => setSuccessToastVisible(false), 3000)
          }
        } catch {
          if (setErrorToastVisible) {
            setErrorToastVisible(true)
            setTimeout(() => setErrorToastVisible(false), 3000)
          }
        } finally {
          setDefectCommentFormSubmitting(false)
        }
      }}
    >
      <Input
        rows={3}
        value={comment}
        onChange={(e) => setComment(e)}
        placeholder={t('defect.comment.placeholder')}
      />
      <TransparentButton
        type="submit"
        disabled={comment.trim().length === 0 || defectCommentFormSubmitting}
        submitting={defectCommentFormSubmitting}
      >
        {t('defect.comment.submit')}
      </TransparentButton>
    </CommentForm>
  )
}
